import dayjs from 'dayjs';
import { GuidT, CookieOptionsT } from '@/types/common';
import { LoginDataIF } from '@/api/authApi/types';
import { setCookie, deleteCookie } from '@/helpers/storage';

const COOKIE_OPTIONS: CookieOptionsT = {
    secure: true,
    samesite: 'Strict',
};

export const refreshToken = async (
    refreshToken: string,
    userGuid: GuidT,
): Promise<LoginDataIF | null> => {
    try {
        const response = await fetch(
            `${import.meta.env.VITE_API_ENDPOINT}/Auth/RefreshToken`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    refreshToken,
                    userGuid,
                }),
            },
        );

        if (!response.ok) {
            return null;
        }

        const contentType = response.headers.get('content-type');
        const isJson = contentType?.includes('application/json');

        if (!isJson) {
            return null;
        }

        let data: LoginDataIF;

        try {
            data = await response.json();

            if (!data.token || !data.refreshToken || !data.guid) {
                return null;
            }
        } catch {
            return null;
        }

        const refreshTokenExpiresDate = dayjs()
            .add(data.refreshTokenExpireIn, 'second')
            .toDate();

        setCookie('refreshToken', data.refreshToken, {
            ...COOKIE_OPTIONS,
            expires: refreshTokenExpiresDate,
        });
        setCookie('userGuid', data.guid, {
            ...COOKIE_OPTIONS,
            expires: refreshTokenExpiresDate,
        });
        setCookie('token', data.token, {
            ...COOKIE_OPTIONS,
            expires: dayjs().add(data.tokenExpireIn, 'second').toDate(),
        });

        return data;
    } catch {
        return null;
    }
};

export const clearAuthData = (): void => {
    deleteCookie('token');
    deleteCookie('refreshToken');
    deleteCookie('userGuid');
};
